import { createContext } from "react";
import { IReviewState } from "state/ReviewState";

export default createContext<IReviewState>({} as IReviewState);
